import { useContext, useEffect } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { ConfigContext } from 'Context/config';

const ON = 'on';
const OFF = 'off';

export const useBinaryExperiment = (flag: string, onKey: string = ON) => {
  const { optimizely } = useContext(OptimizelyContext);
  const { configState: { experimentDecisions } } = useContext(ConfigContext);
  const experimentVariant = experimentDecisions?.[flag] ?? OFF;

  useEffect(() => {
    optimizely?.onReady().then(() => {
      if (experimentDecisions?.[flag]) {
        optimizely.decide(flag);
      }
    });
  }, [experimentDecisions, optimizely, flag]);

  return experimentVariant === onKey;
};
